import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Cutelaria = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Cutelaria";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.higieneCutelaria})` }}>
        <div className="servico-hero-overlay">
          <h1>Cutelaria</h1>
          {/* <p>Para quem procura por cutelaria</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Higiene Pessoal e Cutelaria */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.manicure} alt="" /></div>
            <h3>Manicure</h3>
            <p>Tesouras e pinças.</p>
          </div>


          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.cortadoresCutelaria} alt="" /></div>
            <h3>Cortadores</h3>
            <p>Cortadores de unha e cutícula.</p>
          </div>

          <div></div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('cutelaria')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('cutelaria')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Cutelaria;